import { useTrackAnalyticsCache } from '@/hooks/useTrackAnalyticsCache'
import { AnalyticsTrackingItem } from '@/types/analytics_monitor.type'

interface AnalyticsMonitorProps {
  item: AnalyticsTrackingItem
}

const AnalyticsMonitor: React.FC<AnalyticsMonitorProps> = ({ item }) => {
  useTrackAnalyticsCache({
    messageId: item.messageId,
    conversationId: item.conversationId,
    onComplete: () => {},
  })

  return null
}

export default AnalyticsMonitor
